/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Primary_ColourInputs */

const en_field_primary_colour = /** @type {(inputs: Field_Primary_ColourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primary colour`)
};

/**
* | output |
* | --- |
* | "Primary colour" |
*
* @param {Field_Primary_ColourInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const field_primary_colour = /** @type {((inputs?: Field_Primary_ColourInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Primary_ColourInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_field_primary_colour(inputs)
});